import React from 'react';
import { StyledLabel } from '../../../assets/styledComponents/Global';
import PortletHeaderTabs from './PortletHeaderTabs';
import styled, { useTheme } from 'styled-components';
// import ArrowButtonIcon from '../svgIcons/ArrowButtonIcon';
import ArrowIcon from '../svgIcons/ArrowIcon';

const PortletHeader = ({
  title = '',
  headerClassName = '',
  containerClassName = '',
  actions,
  subTitle,
  borderBottom,
  tabs,
  tabsVariant,
  titleDetails,
  filters,
  onChangeTabs,
  breadCrumb,
  counts,
  count,
  tag,
  id,
  labelClassName = '',
  wizard,
  wizardTemp,
  search,
  backLink,
  tabsFlush = false,
}) => {
  const theme = useTheme();
  const hasTabs = Array.isArray(tabs) ? tabs.length > 0 : !!tabs;
  const tabsInside = hasTabs && !tabsFlush;
  const tabsBar = hasTabs ? (
    <div
      className={`portlet__header pb-0 ${tabsFlush ? 'portlet__header--flush' : ''} ${headerClassName} ${
        borderBottom ? 'portlet__header-border' : ''
      }`}
    >
      <div className={breadCrumb ? '' : 'flex-grow-1'}>
        <PortletHeaderTabs
          tabs={tabs}
          onChangeTabs={onChangeTabs}
          title={title}
          wizardTemp={wizardTemp}
          variant={tabsVariant}
        />
      </div>
    </div>
  ) : null;

  return (
    <>
    <div
      className={`portlet__header-container ${
        /\brounded/.test(containerClassName) ? '' : 'rounded'
      } ${wizard ? '_1-step' : ''} ${!hasTabs ? 'isHeadingOnly' : ''
        } ${containerClassName}`}
    >
      {counts && <div className="mb-1">{counts}</div>}

      <div className="flex-center flex-wrap">
        {backLink && <ArrowIcon rotate='left' className='me-2 cursor-pointer' onClick={() => (window.location.href = backLink)} color={theme?.primary} />}
        {title && (
          <h2 className="flex-grow-1 m-0 fw-normal">
            <span className={`${tag && 'd-flex align-items-center'} `}>
              <span className='portlet-header-title'>
                {title ?? ''}
                {count && <HeaderCount>{count}</HeaderCount>}
              </span>
              {tag && <span>{tag}</span>}
            </span>
            {subTitle && <span className="fw-normal fs-4 portlet-header-subtitle text-secondary">{subTitle}</span>}
          </h2>
        )}
        {breadCrumb && <div className="flex-grow-1 ">{breadCrumb}</div>}
        {actions && <div>{actions}</div>}
      </div>

      {titleDetails && (
        <StyledLabel
          size="14px"
          weight="500"
          color={theme?.textSecondary || theme?.primaryText || theme.borderColor}
          className={labelClassName}
        >
          {titleDetails}
        </StyledLabel>
      )}

      {tabsInside && (
      <div
        className={
          breadCrumb ? 'd-flex justify-content-center ' : 'flex-center flex-wrap'
        }
      >
        <div className={breadCrumb ? '' : 'flex-grow-1'}>
          {tabsBar}
        </div>
        <div className="display-flex">{filters && <div>{filters}</div>}</div>
      </div>
      )}
      <div >{search && <div>{search}</div>}</div>

    </div>
    {tabsFlush ? tabsBar : null}
    </>
  )
};

const HeaderCount = styled.span`
  margin-left: 6px;
  font-size: inherit;
  font-weight: inherit;
  font-family: inherit;
  line-height: inherit;
  color: ${({ theme }) => theme.secondary || '#dc601e'} !important;
`;

export default PortletHeader;
